import React from 'react'
import swal from '@sweetalert/with-react'
import { withPopupTheme } from '../withPopupTheme'
import { PopUpContainer, PopUpContent, PopUpHeader, PopUpParagraph, PopUpTitle } from './style'

export interface DoubleActionAlertProps {
  title: string
  message: string
  buttons: Array<{ text: string, value?: string | null }>
  action?: (value?: string | null) => void | Promise<void>
}

export const showDoubleActionPopUp = ({ title, message, buttons, action = () => { } }: DoubleActionAlertProps): void => {
  const [confirm, cancel] = buttons

  swal({
    buttons: {
      confirm: {
        text: confirm.text,
        value: confirm.value,
        className: 'popup-button-confirm'
      },
      cancel: cancel.text,
    },
    closeOnEsc: false,
    allowOutsideClick: false,
    content: withPopupTheme(
      <PopUpContainer>
        <PopUpHeader>
          <PopUpTitle>{title}</PopUpTitle>
        </PopUpHeader>
        <PopUpContent>
          <PopUpParagraph>{message}</PopUpParagraph>
        </PopUpContent>
      </PopUpContainer>
    )
  }).then((value: string) => {
    if (value === confirm.value || (confirm.value === undefined && value === confirm.text)) {
      action(value)
    }
  })
}
